import React from "react";
import upIcon from "src/assets/i_up.svg";
import downIcon from "src/assets/i_down.svg";


interface UpDownLabelProp {
  change?: number;
  label?: string;
}

const UpDownLabel: React.FC<UpDownLabelProp> = ({ change, label }) => {
  return (
    <span className={`${change < 0 ? "stat-change-down d-flex align-items-center gap-2" : "stat-change d-flex align-items-center gap-2"}`}>
        <i><img src={ change < 0 ? downIcon : upIcon } alt="" /></i> {Math.abs(change).toLocaleString()}{label==="오늘 누적 게시글"?"%":null}
    </span>
  );
};
export default UpDownLabel;
